// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Reporting_toolbar__2Znmo","tableWrap":"Reporting_tableWrap__2txi7"};